import { useSuspenseQuery } from '@apollo/client';

import { MostVisitedCompaniesOrder } from '@xing-com/crate-common-graphql-types';
import { useExperiment } from '@xing-com/hub';

import { XcpMostVisitedCompaniesDocument } from '../../graphql/queries/most-visited-companies.gql-types';

export const ORDERS = {
  RANDOM: MostVisitedCompaniesOrder.Random,
  VISITS_COUNT_DESC: MostVisitedCompaniesOrder.VisitsCountDesc,
};

type MostVisitedCompaniesProps = {
  limit: number;
  offset?: number;
};

const useMostVisitedCompanies = ({
  limit = 4,
  offset = 0,
}: MostVisitedCompaniesProps) => {
  const variables = {
    limit,
    offset,
    order: ORDERS.RANDOM,
    shouldHideKununuData: useExperiment('ABACUS-518') === 'B',
  };
  const { error, ...rest } = useSuspenseQuery(XcpMostVisitedCompaniesDocument, {
    variables,
    errorPolicy: 'all',
  });

  return {
    error,
    ...rest,
  };
};

export { useMostVisitedCompanies };
